import { useLocale } from "../../hooks/useLocale";
import { msg } from "../../locales/translate";
import { VBox } from "@ui/box/Box";
import Button from "@ui/button/Button";
import { Error } from "@ui/error/Error";
import { Form } from "@ui/form/Form";
import Panel from "@ui/panel/Panel";
import Signal from "badmfck-signal";
import { useState } from "react";
import { GD } from "src/GD";

export const S_ADD_STATUS_POPUP = new Signal<{} | null>("S_ADD_STATUS_POPUP");

const initialForm: IStatusNormilized = {
	gate_id: 0,
	id: -1,
	name: "",
	weight: 0,
};

export const AddStatusPopup = () => {
	useLocale();
	const requestData = S_ADD_STATUS_POPUP.use();
	const [busy, setBusy] = useState<boolean>();
	const [error, setError] = useState<IError>();
	const [form, setForm] = useState<IStatusNormilized>({ ...initialForm });

	if (!requestData) return null;

	const handleSubmit = async () => {
		setError(undefined);
		setBusy(true);

		const res = await GD.BALANCER.REQ_STATUS_ADD.request(form);
		if (!res.error) {
			S_ADD_STATUS_POPUP.invoke(null);
		} else {
			setError(res.error);
		}

		setBusy(false);
	};

	const closePopup = () => {
		S_ADD_STATUS_POPUP.invoke(null);
		setError(undefined);
		setForm({ ...initialForm });
	};

	//!TODO: move status render to component;
	return (
		<Panel
			sx={{
				//width: "90vw",
				maxWidth: "1200px",
				height: "80vh",
				padding: "0",
				minWidth: "500px",
				//width:'40vw'
			}}
			decorator="absolute"
			busy={busy}
			label={msg("addNewStatus")}
			onClose={closePopup}>
			<VBox
				gap="20px"
				sx={{
					overflow: "auto",
					flexGrow: 1,
					padding: "40px 20px",
					backgroundColor: "#EEF0F2",
				}}>
				<Form
					data={form}
					decorator={[
						{
							direction: "row",
							fields: [
								{
									name: "name",
									label: msg("statusName"),
								},
							],
						},

						{
							direction: "row",
							fields: [
								{
									name: "weight",
									label: msg("weight"),
								},
								{
									name: "gate_id",
									label: msg("gateId"),
								},
							],
						},
					]}
				/>
			</VBox>

			<VBox sx={{ padding: "20px", gap: "12px" }}>
				<Error error={error} />
				<Button
					title={msg("submit")}
					onClick={() => {
						handleSubmit();
					}}
				/>
			</VBox>
		</Panel>
	);
};
